export type NavigateFunction = (href: string) => void;

export const navigateTo = (href: string) => {
  window.location.href = href;
};

/**
 * Replace the current entry instead of pushing a new one. Used when the page
 * is a one-shot relay the user must not be able to come back to: a buffer page
 * that redirects on load would redirect again on the way back, trapping the
 * user between the destination and the relay.
 */
export const replaceWith = (href: string) => {
  window.location.replace(href);
};
